import { useMemo } from 'react';
import get from 'lodash/get';

import { STATUS_SURVEY } from '../VisitSurveyListView/constants';

export function useInfoConsentWithAppointments(isProviderContext, appointment) {
  const {
    userId,
    service,
    dateTime,
    providerInfo,
    requiredSurveys,
    consentsAssignment,
    surveyAssignments = [],
  } = appointment;

  const serviceName = service ? service.name : '';

  const isAllSignedConsents = consentsAssignment
    ? consentsAssignment.allSigned
    : true;

  const allConsents =
    consentsAssignment && consentsAssignment.consents
      ? consentsAssignment.consents
      : [];
  const notSignedConsent = allConsents.filter(item => !item.accepted);

  const notSignedPreVisits = surveyAssignments.filter(
    form =>
      ![STATUS_SURVEY.COMPLETED, STATUS_SURVEY.EXPIRED].includes(form.status) &&
      !!form.survey.required,
  );

  const organizationName = isProviderContext
    ? ''
    : get(providerInfo, 'organization.name', '');

  return useMemo(
    () => ({
      dateTime,
      allConsents,
      serviceName,
      organizationName,
      notSignedPreVisits,
      isAllSignedConsents,
      patientUserInfoId: userId,
      notSignedConsent: notSignedConsent[0],
      isRequiredPreVisitForms: requiredSurveys,
    }),
    [
      userId,
      dateTime,
      allConsents,
      serviceName,
      requiredSurveys,
      notSignedConsent,
      organizationName,
      notSignedPreVisits,
      isAllSignedConsents,
    ],
  );
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/useInfoConsentWithAppointments.js